import { useEnvStore } from '../stores/use-env'

/**
 * 监听环境配置变化
 * @param fn 回调函数
 */
export const useConfigWatchEffect = (fn: () => Promise<void>) => {
  const envStore = useEnvStore()
  const queue: (() => Promise<void>)[] = []
  const isLoading = ref(false)

  const run = async () => {
    if (isLoading.value) return
    isLoading.value = true
    await Promise.all(queue)
    isLoading.value = false
  }

  watch(
    () => envStore.config.app,
    async (currentAppUrl, oldAppUrl) => {
      if (currentAppUrl === oldAppUrl || !currentAppUrl) return
      if (isLoading.value) {
        queue.push(fn)
        return
      }
      isLoading.value = true
      await fn()
      isLoading.value = false
      run()
    },
    {
      immediate: true,
      deep: true,
    },
  )
}
